import {IStandingsAlgorithm} from './IStandingsAlgorithm';
import {ITeamRegistration} from '../models/ITeamRegistration';
import _ from 'lodash';

export class StandingsAlgorithmWLHTHPA implements IStandingsAlgorithm {

    public sortStandings(teamregistrations: ITeamRegistration[]): ITeamRegistration[] {
        return  _.orderBy(teamregistrations, ['wins', 'losses', 'hth', 'pa'], ['desc', 'asc', 'desc', 'asc']); 
    }    
}
